/**
 * El aviso de que las marcas o etiquetas del proyecto cambiaron: lo dan los
 * guardados de ofertas y colecciones y las eliminaciones, y lo escucha
 * `useOfferLabels` para volver a pedirlas. Aparte y sin importar nada, porque
 * `api.ts` lo llama y `offerLabels.ts` importa `api.ts`.
 */
type Listener = (projectId: string) => void
const listeners = new Set<Listener>()

export function markOfferLabelsStale(projectId: string): void {
  listeners.forEach((listener) => listener(projectId))
}

export function onOfferLabelsStale(listener: Listener): () => void {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}
